<template>
  <div class="dialog-warp">
    <el-form ref="info" size="small" :model="approvalInfo" label-width="120px">
      <el-row class="dialog-form">
        <el-col class="g-basic-info">
          <el-row>
                您还可以新增：{{num}} 人
          </el-row>
        </el-col>
      </el-row>

      <h3 class="title">
        选择员工：
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          class="title-label-right"
        >全选</el-checkbox>
      </h3>

      <el-row class="dialog-form" >
        <el-col class="g-basic-info">
          <el-row>
            <!-- <el-form-item label-width="180px" label="审批结果：" prop="result"> -->
            <el-checkbox-group v-model="checkedStaff" @change="handlecheckedStaffChange">
              <el-checkbox
                v-for="(item,index) in staffs"
                :label="item"
                :key="index"
                style="display:block;"
              >
                <span class="g-text"> {{item.baseName}}</span>
      
                <span class="g-text"> {{item.basePhone}}</span>
                <span class="g-green" v-if="item.healthCodeType==1">自由通行</span>
                <span class="g-red" v-if="item.healthCodeType==2">受限制</span>
              
              </el-checkbox>
            </el-checkbox-group>
            <!-- </el-form-item> -->
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <div class="text-right" style="margin-top: 20px;">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="success" @click="submit" size="small" :loading="submitLoading" :disabled="isDisabled">确认</el-button>
    </div>
  </div>
</template>
<script>
import * as global from "../../config/mUtils";
import * as getData from "../../service/getData";
export default {
  data() {
    return {
      approvalInfo: {
        baseIds: []
      },
      submitLoading: false,
      checkAll: false,
      checkedStaff: [],
      staffs: [],
      isIndeterminate: true,
      num:"",
      isDisabled:false,
    };
  },
  created() {},
  mounted() {
     getData
        .viralInfoPersonToAdd()
        .then(res => {
          if (res.data.code != 1) {
            this.$message.error(res.data.message);
            return;
          }

          this.staffs = res.data.data.downList;
          this.num = res.data.data.num
        })
        .catch(_ => {
          console.log(_);
        });
  },
  props: ["approvalTitle","erAuditId"],
  computed: {},
  methods: {
    close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    handleCheckAllChange(val) {
      this.checkedStaff = val ? this.staffs : [];
      this.approvalInfo.baseIds = this.checkedStaff.map(item => {
        return item.baseId;
      });
      this.approvalInfo.baseIds = this.approvalInfo.baseIds.join(",")
      console.log(this.approvalInfo.baseIds )
      this.isIndeterminate = false;
      if(this.checkedStaff.length >this.num){
        this.isDisabled = true 
        this.$message.error("选择人数不可大于可新增人数!")
      }else {
        this.isDisabled=false
      }
    },
    handlecheckedStaffChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.staffs.length;
      this.approvalInfo.baseIds = this.checkedStaff.map(item => {
        return item.baseId;
      });
      this.approvalInfo.baseIds = this.approvalInfo.baseIds.join(",")
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.staffs.length;
      if(this.checkedStaff.length >this.num){
        this.isDisabled = true 
       this.$message.error("选择人数不可大于可新增人数!")
      }else {
        this.isDisabled=false
      }
    },
    submit() {
      console.log(this.approvalInfo);
      getData
        .viralInfoPersonAdd(this.approvalInfo.baseIds)
        .then(res => {
          if (res.data.code != 1) {
            this.$message.error(res.data.message);
            return;
          }
          this.$message({
            type: "success",
            message: "新增登记成功！"
          });
          this.close(1);
        })
        .catch(_ => {
          this.$message({
            type: "warning",
            message: "新增登记失败！"
          });
        });
    }
  },
  components: {},
  watch: {}
};
</script>
<style scoped lang="scss">
@import "../../assets/css/mixin";
.title-label-right {
  float: right;
  color: #169bd5;
}
.g-text {
    display: inline-block;
    width: 120px;

}
.g-green {
    color:#009966;
}
.g-red {
    color:#ff0000;
}
</style>


// WEBPACK FOOTER //
// src/components/防疫/add-register.vue